import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { CapitalizeFirstLetters } from "../../helpers/utilities";
import { DiliTextCP } from "../Utility/DiliTextCP";
import { useHistory } from "react-router-dom";

import { Modal } from "react-bootstrap";
import { CDKOrderEditingRules } from "../../constants";

export const EditCDKDispatchDestinationModal = ({
  show,
  onHide,
  order,
  originalCDKData,
  onSubmitNewDestination,
}) => {
  const generateInitialFormValues = () => {
    return {
      customerName: order?.customerName ?? "",
      address: order?.address ?? "",
      city: CapitalizeFirstLetters(order?.city) ?? "",
      state: order?.state ?? "",
      zip: order?.zip ?? "",
    };
  };
  const history = useHistory();
  const [formValues, setFormValues] = useState(generateInitialFormValues);

  useEffect(() => {
    if (!show) {
      return;
    }
    //when cdkOrder changes we need to update our values (i.e. we open the modal on a new row) - Changed to be based on show state variable
    setFormValues(generateInitialFormValues);
  }, [show]); //this is working fine even though it is a nested object? - Changed to be based on show anyway, so if they make edits to an order, cancel and reopen the modal we reset

  const handleChangeForm = async (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => {
      return { ...prev, [name]: value };
    });
  };

  // console.log(formValues);

  const [wasSubmitted, setWasSubmitted] = useState(false);
  const [updating, setUpdating] = useState(false);

  const handleOnInvalid = () => {
    setWasSubmitted(true);
  };

  const handleSubmit = async (e) => {
    // console.log("hi");
    e.preventDefault();
    setUpdating(true);
    await onSubmitNewDestination(order.deliveryId, formValues);
    setUpdating(false);
    // onHide();
  };
  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header>
        <Modal.Title>Editing Destination</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit} onInvalid={handleOnInvalid}>
        <Modal.Body style={{ padding: 0 }}>
          <div className="row">
            {/* pr-0 must match breakpoint of col, idk why it is behaving so weirdly without the pr-0 (and pl-0 on the other col below) though, is this how bootstrap always was??? */}
            <div className="col-md-4 pr-md-0">
              <div
                className="cdk-customer-edit-subheader"
                style={{ borderRight: "1px solid #dee2e6" }}
              >
                CDK Data
              </div>
              <div
                style={{ overflow: "auto", borderRight: "1px solid #dee2e6" }}
              >
                <div className="cdk-customer-edit-helper-display-container">
                  <div className="client-profile-info-display-header">
                    Customer Name
                  </div>
                  {originalCDKData?.customerName
                    ? originalCDKData.customerName
                    : "Not Found"}
                </div>
                <div className="cdk-customer-edit-helper-display-container">
                  <div className="client-profile-info-display-header">
                    Customer Name 2
                  </div>
                  {originalCDKData?.customerName2
                    ? originalCDKData.customerName2
                    : "Not Found"}
                </div>
                <div className="cdk-customer-edit-helper-display-container">
                  <div className="client-profile-info-display-header">
                    Customer Address
                  </div>
                  {originalCDKData?.customerAddress
                    ? originalCDKData.customerAddress
                    : "Not Found"}
                </div>
                <div className="cdk-customer-edit-helper-display-container">
                  <div className="client-profile-info-display-header">
                    Customer CSZ
                  </div>
                  {/* // shipToLine1: cdkOrder.shipToLine1,
                // shipToLine2: cdkOrder.shipToLine2,
                // shipToLine3: cdkOrder.shipToLine3,
                // shipToLine4: cdkOrder.shipToLine4,
                // shipVia: cdkOrder.shipVia, */}
                  {originalCDKData?.customerCSZ
                    ? originalCDKData.customerCSZ
                    : "Not Found"}
                </div>
                <div className="cdk-customer-edit-helper-display-container">
                  <div className="client-profile-info-display-header">
                    shipToLine1
                  </div>
                  {originalCDKData?.shipToLine1
                    ? originalCDKData.shipToLine1
                    : "Not Found"}
                </div>
                <div className="cdk-customer-edit-helper-display-container">
                  <div className="client-profile-info-display-header">
                    shipToLine2
                  </div>
                  {originalCDKData?.shipToLine2
                    ? originalCDKData.shipToLine2
                    : "Not Found"}
                </div>
                <div className="cdk-customer-edit-helper-display-container">
                  <div className="client-profile-info-display-header">
                    shipToLine3
                  </div>
                  {originalCDKData?.shipToLine3
                    ? originalCDKData.shipToLine3
                    : "Not Found"}
                </div>
                <div className="cdk-customer-edit-helper-display-container">
                  <div className="client-profile-info-display-header">
                    shipToLine4
                  </div>
                  {originalCDKData?.shipToLine4
                    ? originalCDKData.shipToLine4
                    : "Not Found"}
                </div>
                <div className="cdk-customer-edit-helper-display-container">
                  <div className="client-profile-info-display-header">
                    ShipVia
                  </div>
                  {originalCDKData?.shipVia
                    ? originalCDKData.shipVia
                    : "Not Found"}
                </div>
              </div>
            </div>
            <div className="col-md-8 pl-md-0">
              <div className="cdk-customer-edit-subheader">Data to submit</div>
              <div className="form-row" style={{ padding: "1rem" }}>
                <DiliTextCP
                  required
                  className="col-12 form-group"
                  label="Customer Name"
                  name="customerName"
                  maxLength={CDKOrderEditingRules.customerName.maxLength}
                  value={formValues.customerName}
                  onChange={handleChangeForm}
                  wasSubmitted={wasSubmitted}
                />
                <DiliTextCP
                  required
                  className="col-12 form-group"
                  label="Customer Address"
                  name="address"
                  maxLength={CDKOrderEditingRules.customerAddress.maxLength}
                  value={formValues.address}
                  onChange={handleChangeForm}
                  wasSubmitted={wasSubmitted}
                />
                <DiliTextCP
                  required
                  type="select"
                  label="Customer State"
                  className="col-6 form-group"
                  name="state"
                  value={formValues.state}
                  onChange={handleChangeForm}
                  wasSubmitted={wasSubmitted}
                >
                  <option value="">Select State</option>
                  <option value="AL">AL</option>
                  <option value="AK">AK</option>
                  <option value="AZ">AZ</option>
                  <option value="AR">AR</option>
                  <option value="CA">CA</option>
                  <option value="CO">CO</option>
                  <option value="CT">CT</option>
                  <option value="DE">DE</option>
                  <option value="FL">FL</option>
                  <option value="GA">GA</option>
                  <option value="HI">HI</option>
                  <option value="ID">ID</option>
                  <option value="IL">IL</option>
                  <option value="IN">IN</option>
                  <option value="IA">IA</option>
                  <option value="KS">KS</option>
                  <option value="KY">KY</option>
                  <option value="LA">LA</option>
                  <option value="ME">ME</option>
                  <option value="MD">MD</option>
                  <option value="MA">MA</option>
                  <option value="MI">MI</option>
                  <option value="MN">MN</option>
                  <option value="MS">MS</option>
                  <option value="MO">MO</option>
                  <option value="MT">MT</option>
                  <option value="NE">NE</option>
                  <option value="NV">NV</option>
                  <option value="NH">NH</option>
                  <option value="NJ">NJ</option>
                  <option value="NM">NM</option>
                  <option value="NY">NY</option>
                  <option value="NC">NC</option>
                  <option value="ND">ND</option>
                  <option value="OH">OH</option>
                  <option value="OK">OK</option>
                  <option value="OR">OR</option>
                  <option value="PA">PA</option>
                  <option value="RI">RI</option>
                  <option value="SC">SC</option>
                  <option value="SD">SD</option>
                  <option value="TN">TN</option>
                  <option value="TX">TX</option>
                  <option value="UT">UT</option>
                  <option value="VT">VT</option>
                  <option value="VA">VA</option>
                  <option value="WA">WA</option>
                  <option value="WV">WV</option>
                  <option value="WI">WI</option>
                  <option value="WY">WY</option>
                </DiliTextCP>
                <DiliTextCP
                  required
                  // type="select"
                  label="City"
                  name="city"
                  onChange={handleChangeForm}
                  value={formValues.city}
                  className="col-6 form-group"
                  wasSubmitted={wasSubmitted}
                />
                <DiliTextCP
                  required
                  label="Zip Code"
                  name="zip"
                  maxLength={CDKOrderEditingRules.customerZip.maxLength}
                  value={formValues.zip}
                  onChange={handleChangeForm}
                  wasSubmitted={wasSubmitted}
                  pattern="^[0-9]{5}(?:-[0-9]{4})?$"
                  helperText={"55555 ( -5555 )"}
                  showHelperText
                  className="col-6 form-group"
                />
                {/* <div className="col-6"></div>
                <div className="col-6">
                  <div className="border rounded">
                    <div className="list-border-bottom p-2">
                      Suggested Address
                    </div>
                    <div className="p-2">TO DO</div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onHide}
            disabled={updating}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary" disabled={updating}>
            {updating ? "Updating..." : "Update"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
